import PolicyTipsOverrideDialog from '../components/PolicyTipsOverrideDialog';
import PolicyTipsViewState from '../store/schema/PolicyTipsViewState';
import { showModal } from 'owa-modal';
import setIsFalsePositive from '../actions/setIsFalsePositive';
import setOverrideJustification from '../actions/setOverrideJustification';

export default function showPolicyTipsOverrideDialog(viewState: PolicyTipsViewState) {
    const [modalPromise] = showModal(PolicyTipsOverrideDialog);
    modalPromise.then(overrideState => {
        if (overrideState) {
            if (overrideState.isFalsePositive) {
                setIsFalsePositive(viewState, true);
            } else if (overrideState.justification && overrideState.justification.length > 0) {
                setOverrideJustification(viewState, overrideState.justification);
            }
        }
    });
}
